export const explicacionContrato = [
  {
    title: "Guía de secciones clave y personalizables en un contrato ERC20",
    value: `
A continuación se explican, **una por una**, las secciones más importantes que encontrarás al revisar o personalizar tu contrato ERC20.  
Incluye consejos sobre si debes o no modificarlas, y recomendaciones de seguridad para evitar errores comunes.

---

- **Versión del compilador**  
  \`pragma solidity ^0.8.0;\`  
  Indica la versión de Solidity que usará Remix o Hardhat.  
  **Importante:** La versión ^0.8.0 protege automáticamente contra errores de desbordamiento (*overflow*).  
   *Tip de seguridad:* Usa siempre una versión actual y estable de Solidity. Evita versiones antiguas como 0.4.x en proyectos reales.  
  *(No editable)*

---

- **Interfaz ERC20**  
  \`interface IERC20\`  
  Define la estructura del estándar ERC20, lo que hace que tu token sea reconocido por exchanges, wallets y DApps.  
   *Tip de seguridad:* No modifiques esta interfaz. Así aseguras compatibilidad con MetaMask, Uniswap y otras herramientas.  
  *(No editable)*

---

- **Contrato Owned**  
  \`contract Owned\`  
  Permite que el contrato tenga un propietario (owner) que puede transferir la propiedad. Controla funciones críticas como recuperar tokens perdidos.  
   *Tip de seguridad:* Nunca dejes el contrato en manos de una sola persona en proyectos públicos. Considera multisig (ej. Gnosis Safe).  
  *(No editable, solo si quieres cambiar la lógica de propiedad)*

---

- **Nombre del token**  
  \`string public name = "TootyrToken";\`  
  Define el nombre que verán los usuarios en wallets y exploradores.  
   *Editable:* Personaliza aquí con el nombre de tu proyecto/token.  
   *Tip de seguridad:* No uses nombres similares a tokens famosos para evitar confusiones o fraudes.

---

- **Símbolo del token**  
  \`string public symbol = "TRT";\`  
  Es el identificador corto del token (como BTC, ETH, USDT).  
   *Editable:* Elige un símbolo único, idealmente de 3 a 5 letras.  
   *Tip de seguridad:* Evita símbolos confusos o idénticos a otros tokens.

---

- **Número de decimales**  
  \`uint8 public decimals = 18;\`  
  Define cuántos decimales puede tener tu token. El estándar es 18 (igual que ETH).  
   *Editable:* Puedes cambiarlo, pero 18 es el valor más aceptado.  
   *Tip de seguridad:* No uses 0 a menos que quieras un token indivisible.

---

- **Suministro total (totalSupply)**  
  \`uint public override totalSupply\`  
  Es la cantidad total de tokens que existirán. Se define típicamente en el constructor, ej: 100 millones con 18 decimales.  
   *Editable:* Calcula bien el total: ej. 1 millón = 1_000_000 * 10 ** 18.  
   *Tip de seguridad:* Un error en este cálculo puede hacer que tu token tenga más o menos unidades de lo que esperas.

---

- **Constructor**  
  \`constructor()\`  
  Asigna todos los tokens al propietario inicial (usualmente \`msg.sender\`). Solo se ejecuta una vez al desplegar.  
   *Opcionalmente editable:* Puedes cambiar \`msg.sender\` por otra dirección fija si quieres distribuir tokens a otra cuenta.  
   *Tip de seguridad:* No dejes el supply en una dirección que no controles.

---

- **Funciones principales ERC20**  
  \`transfer, approve, transferFrom\`  
  Permiten enviar tokens, aprobar a otros y mover tokens con permiso.  
   *No editable:* No modifiques estas funciones a menos que seas un desarrollador avanzado.  
   *Tip de seguridad:* Cambiar estas funciones puede romper la compatibilidad ERC20.

---

- **Función de rescate de tokens**  
  \`transferAnyERC20Token\`  
  Permite al owner recuperar tokens ERC20 enviados por error a este contrato.  
   *Opcionalmente editable:* Úsala solo para soporte técnico y nunca para tomar fondos de otros sin permiso.  
   *Tip de seguridad:* Es una práctica común, pero informa a tus usuarios de su existencia.

---

Lee y comprende cada sección antes de personalizar tu contrato.  
Modifica solo las partes recomendadas y sigue las mejores prácticas de seguridad para lanzar un token profesional y confiable.
`
  }
];

export default explicacionContrato;
